"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RetirementIncomeGapPageTwo;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _RetirementIncomeGapFormControls = require("./RetirementIncomeGapFormControls");
var _utils = require("../../middleware/utils");
var _RetirementIncomeGapWizardCalc = require("./RetirementIncomeGapWizardCalc.config");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function RetirementIncomeGapPageTwo(_ref) {
  var {
    setFutureExpenses
  } = _ref;
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();
  var ageDifference = parseInt(values.retirementAge) - parseInt(values.currentAge);
  (0, _react.useEffect)(() => {
    document.getElementById(_RetirementIncomeGapWizardCalc.calcName).scrollIntoView();
    /* istanbul ignore else*/
    if (window) {
      window.scrollBy(0, -112);
    }
  }, []);
  (0, _react.useEffect)(() => {
    setFutureExpenses(sumFutureExpenses());
  }, [values.futureInflated_housingAndInsuranceCost, values.futureInflated_healthcareAndInsuranceCost, values.futureInflated_transportationAndInsuranceCost, values.futureInflated_groceriesAndDiningOutCost, values.futureInflated_travelAndEntertainmentCost, values.futureInflated_personalAndMiscellaneousCost]);
  (0, _react.useEffect)(() => {
    setFieldValue('futureInflated_housingAndInsuranceCost', futureValue(values.future_housingAndInsuranceCost, ageDifference, (0, _utils.parseFloatCurrencyString)(null, values.housingExpenses)));
    setFieldValue('futureInflated_healthcareAndInsuranceCost', futureValue(values.future_healthcareAndInsuranceCost, ageDifference, (0, _utils.parseFloatCurrencyString)(null, values.healthCareAndInsuranceExpenses)));
    setFieldValue('futureInflated_transportationAndInsuranceCost', futureValue(values.future_transportationAndInsuranceCost, ageDifference, (0, _utils.parseFloatCurrencyString)(null, values.transportationExpenses)));
    setFieldValue('futureInflated_groceriesAndDiningOutCost', futureValue(values.future_groceriesAndDiningOutCost, ageDifference, (0, _utils.parseFloatCurrencyString)(null, values.groceriesAndEatingOutExpenses)));
    setFieldValue('futureInflated_travelAndEntertainmentCost', futureValue(values.future_travelAndEntertainmentCost, ageDifference, (0, _utils.parseFloatCurrencyString)(null, values.travelAndEntertainmentExpenses)));
    setFieldValue('futureInflated_personalAndMiscellaneousCost', futureValue(values.future_personalAndMiscellaneousCost, ageDifference, (0, _utils.parseFloatCurrencyString)(null, values.personalExpenses)));
    // Creating permanent record if the future value fields have been touched, so we can properly handle persitance logic
    // The field formikAutoTouchOnSubmit will only be true when the submit/next button is pressed and ALL formik fields get auto touched
    // When this happens we do not want to indavertanly call any setFieldValue since formik will say all fields were touched
    // We only want the setFieldValue functions to run when fields are truly touched, not when formik auto touches all fields
    if (touched.future_housingAndInsuranceCost && !touched.formikAutoTouchOnSubmit) {
      setFieldValue('touched_future_housingAndInsuranceCost', true);
    }
    if (touched.future_healthcareAndInsuranceCost && !touched.formikAutoTouchOnSubmit) {
      setFieldValue('touched_future_healthcareAndInsuranceCost', true);
    }
    if (touched.future_transportationAndInsuranceCost && !touched.formikAutoTouchOnSubmit) {
      setFieldValue('touched_future_transportationAndInsuranceCost', true);
    }
    if (touched.future_groceriesAndDiningOutCost && !touched.formikAutoTouchOnSubmit) {
      setFieldValue('touched_future_groceriesAndDiningOutCost', true);
    }
    if (touched.future_travelAndEntertainmentCost && !touched.formikAutoTouchOnSubmit) {
      setFieldValue('touched_future_travelAndEntertainmentCost', true);
    }
    if (touched.future_personalAndMiscellaneousCost && !touched.formikAutoTouchOnSubmit) {
      setFieldValue('touched_future_personalAndMiscellaneousCost', true);
    }
  }, [values.future_housingAndInsuranceCost, values.future_healthcareAndInsuranceCost, values.future_transportationAndInsuranceCost, values.future_groceriesAndDiningOutCost, values.future_travelAndEntertainmentCost, values.future_personalAndMiscellaneousCost, touched]);
  function sumFutureExpenses() {
    return 0 + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_housingAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_healthcareAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_transportationAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_groceriesAndDiningOutCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_travelAndEntertainmentCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_personalAndMiscellaneousCost));
  }
  function futureValue(startingValue, years, inflationRate) {
    var numericValue = (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, startingValue)) * (1 + inflationRate / 100) ** years;
    return (0, _utils.numberToCurrencyString)(numericValue, 0, false);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", null, "Housing & Insurance"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.SecondaryHousingAndInsurance, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto input-and-buttons-inline"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.FutureHousingAndInsurance, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("h3", null, "Healthcare & Insurance"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.SecondaryHealthcareAndInsurance, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto input-and-buttons-inline"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.FutureHealthcareAndInsurance, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("h3", null, "Transportation & Insurance"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.SecondaryTransportationAndInsurance, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto input-and-buttons-inline"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.FutureTransportationAndInsurance, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("h3", null, "Groceries & Dining Out"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.SecondaryGroceriesAndDiningOutCost, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto input-and-buttons-inline"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.FutureGroceriesAndDiningOutCost, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("h3", null, "Travel & Entertainment"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.SecondaryTravelAndEntertainmentCost, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto input-and-buttons-inline"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.FutureTravelAndEntertainmentCost, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("h3", null, "Personal & Miscellaneous"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.SecondaryPersonalAndMiscellaneousCost, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto input-and-buttons-inline"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.FuturePersonalAndMiscellaneousCost, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }))));
}